import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { logoUrl } from "../../../Services/EndPoints";

const LogosToggler = () => {
  const { presentTheme } = useSelector((state) => state.data);
  const [logoFileName, setLogoFileName] = useState("");

  useEffect(() => {
    setTimeout(() => {
      const activeThemeElement = document.getElementById(presentTheme);
      if (!activeThemeElement) {
        console.warn("No theme found!");
        return;
      }
      const themeStyles = getComputedStyle(activeThemeElement);
      const fileName = themeStyles.getPropertyValue("--logo-color").trim();
      setLogoFileName(fileName);
    }, 150);
  }, [presentTheme]);

  const logoSrc = `${logoUrl}${logoFileName}`;

  return (
    <div>
      {logoFileName && (
        <img
          src={logoSrc}
          className=" mx-2 cursor-pointer"
          alt="Common Dashboard Logo"
          height={"auto"}
          width={"200px"}
        />
      )}
    </div>
  );
};

export default LogosToggler;
